<template>
  <div
    class="grid grid-cols-12 clamp-gap-4-4"
    :class="{
      'clamp-gap-y-8-8': component === 'ModuleCards',
    }">
    <div
      v-for="(card, idx) in cards"
      :key="card._uid"
      class="effect-hover-tilt-parent"
      :class="{
        // mobile-large 2 or 3 first cards span 12 cols while the rest span 6 cols - prevents lonely card on last line
        'col-span-12': idx < 2 || (idx === 2 && cards.length % 2),
        'col-span-6': !(idx < 2 || (idx === 2 && cards.length % 2)),
        // ALTERNATIVE LAYOUT - mobile-large - alternate between span 12 and 6 columns - if the second last is 12 cols make it 6 col instead to avoid lonely card on the last row
        // 'col-span-12': idx % 3 === 0 && idx + 1 !== cards.length - 1,
        // 'col-span-6': !(idx % 3 === 0 && idx + 1 !== cards.length - 1),
        // tablet-portrait - follow the layout below
        'tp:col-span-12': layouts[cards.length - 1][idx] === 12,
        'tp:col-span-6': layouts[cards.length - 1][idx] === 6,
        'tp:col-span-4': layouts[cards.length - 1][idx] === 4,
        'tp:col-span-3': layouts[cards.length - 1][idx] === 3,
      }">
      <SbElementSpotlightGridCard
        v-if="card.component === 'ElementSpotlightCard'"
        :blok="card"
        :tintOpacity="tintOpacity"
        :sizes="[
          { vw: (layouts[cards.length - 1][idx] / 12) * 100, bpMin: 'tp' },
          {
            vw: idx < 2 || (idx === 2 && cards.length % 2) ? 100 : 50,
            bpMin: '0',
          },
        ]" />
      <SbElementCardsCard
        v-else
        :blok="card"
        :roundedMedia="roundedMedia"
        :sizes="[
          { vw: (layouts[cards.length - 1][idx] / 12) * 100, bpMin: 'tp' },
          {
            vw: idx < 2 || (idx === 2 && cards.length % 2) ? 100 : 50,
            bpMin: '0',
          },
        ]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ElementCardsCardStoryblok,
  ElementSpotlightCardStoryblok,
  ModuleCardsStoryblok,
  ModuleSpotlightStoryblok,
} from "@/types";

interface Props {
  component:
    | ModuleSpotlightStoryblok["component"]
    | ModuleCardsStoryblok["component"];
  cards: ElementSpotlightCardStoryblok[] | ElementCardsCardStoryblok[];
  tintOpacity?: number;
  roundedMedia?: boolean;
}
defineProps<Props>();

const rows = (arrs: number[][]) => arrs.flat();

const one = [12];
const two = [6, 6];
const three = [4, 4, 4];
const four = [3, 3, 3, 3];

// the layout below currently supports 1-30 cards
const layouts = [
  // 1-10
  rows([one]),
  rows([two]),
  rows([three]),
  rows([four]),
  rows([two, three]), // means that in the first row there are 2 cards and in the second row there are 3 cards
  rows([two, four]),
  rows([three, four]),
  rows([two, three, three]),
  rows([two, three, four]),
  rows([three, three, four]),
  // 11-20
  rows([three, four, four]),
  rows([two, three, three, four]),
  rows([two, three, four, four]),
  rows([two, three, three, three, three]),
  rows([two, three, three, three, four]),
  rows([two, three, three, four, four]),
  rows([two, three, three, three, three, three]),
  rows([two, three, three, three, three, four]),
  rows([two, three, three, three, four, four]),
  rows([two, three, three, three, three, three, three]),
  // 21-30
  rows([two, three, three, three, three, three, four]),
  rows([two, three, three, three, three, four, four]),
  rows([two, three, three, three, three, three, three, three]),
  rows([two, three, three, three, three, three, three, four]),
  rows([two, three, three, three, three, three, four, four]),
  rows([two, three, three, three, three, three, three, three, three]),
  rows([two, three, three, three, three, three, three, three, four]),
  rows([two, three, three, three, three, three, three, four, four]),
  rows([two, three, three, three, three, three, three, three, three, three]),
  rows([two, three, three, three, three, three, three, three, three, four]),
];
</script>

<style scoped></style>
